import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '@/components/Button/Button';
import messages from 'public/icons/messages.svg';

type Props = {
  replies?: boolean;
  collapsed?: boolean;
  handleToggle: () => void;
  commentsSize: number;
};

const LeaveCommentBlock = ({
  replies = false,
  collapsed,
  handleToggle,
  commentsSize,
}: Props) => {
  const isSingle = commentsSize === 1;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={replies ? 0 : '22px'}
      gap="16px"
      overflow="hidden"
      flexWrap="wrap"
    >
      <Button
        sx={{ textTransform: 'none' }}
        variant={collapsed ? 'outlined' : 'contained'}
        onClick={handleToggle}
        small={replies}
      >
        {replies ? 'Reply' : 'Leave a Comment'}
      </Button>
      <Box
        display="flex"
        sx={{ cursor: 'pointer' }}
        gap={2}
        onClick={handleToggle}
      >
        <img alt="" src={messages} width="20px" />
        <Typography
          variant="body1"
          component="span"
          color="#0A444D"
          fontSize="1.125rem !important"
        >
          {commentsSize}{' '}
          {replies
            ? isSingle
              ? 'Reply'
              : 'Replies'
            : isSingle
            ? 'Comment'
            : 'Comments'}
        </Typography>
      </Box>
    </Box>
  );
};

export default LeaveCommentBlock;
